var icons = {
    check: require("../assets/icons/check-icon.png").default,
    close: require("../assets/icons/close-icon.png").default,
    closeBlack: require("../assets/icons/close-icon-black.png").default,
    disable: require("../assets/icons/disable-icon.png").default,
    doc: require("../assets/icons/doc-icon.png").default,
    editBlue: require("../assets/icons/edit-icon-blue.png").default,
    filter: require("../assets/icons/filter-icon.png").default,
    globeBlue: require("../assets/icons/globe-icon.png").default,
    globeGray: require("../assets/icons/globe-icon-gray.png").default,
    headphone: require("../assets/icons/headphone-icon-blue.png").default,
    leftArrow: require("../assets/icons/left-arrow-icon.png").default,
    leftChevron: require("../assets/icons/left-chevron.png").default,
    menu: require("../assets/icons/nav-menu-icon.png").default,
    plus: require("../assets/icons/plus-icon.png").default,
    rightArrow: require("../assets/icons/right-arrow-icon.png").default,
    search: require("../assets/icons/search-icon.png").default,
    searchBlack: require("../assets/icons/search-icon-black.png").default,
    ship: require("../assets/icons/ship-icon.png").default,
    shipBlue: require("../assets/icons/ship-icon-blue.png").default,
    user: require("../assets/icons/user-fill-icon.png").default,
    userGreen: require("../assets/icons/user-icon.png").default,
    verified: require("../assets/icons/verified-icon.png").default,
    checkWhite: require("../assets/icons/check-icon-white.png").default,
    checkblueCircle: require("../assets/icons/check-icon-blue.png").default,
    circle: require("../assets/icons/tick-circle.png").default,
    imagePlaceholder: require("../assets/icons/image-placeholder.png").default,
    closeWhite: require("../assets/icons/close-icon-white.png").default,
    earth: require("../assets/icons/globe-icon-light-gray.png").default,
    arrowDown: require("../assets/icons/arrow-down.png").default,
    closeGray: require("../assets/icons/close-icon-gray.png").default,
    homeBlue: require("../assets/icons/home-icon.png").default,
    heart: require("../assets/icons/heart-icon.png").default,
    redHeart: require("../assets/icons/heart-filled-icon.png").default,
};
export default icons;
